import { usePageLoadStatus as usePageLoadStatusFromContext } from 'src/contexts/PageLoadStatusContext';

// Re-export the hook from context for backward compatibility
export const usePageLoadStatus = usePageLoadStatusFromContext;
